import React, { MouseEvent, useState } from 'react';
import { MenuItemType } from '../../../../ui/components/Common/ContextMenu/ContextMenu';
import { PencilIcon, TrashIcon } from '../../../../ui/icons/icons';
import { MOCK_ORG_USERS } from '../constants';
import { getOrganizationUserColumns } from '../functions';
import { TableColumn } from '../../../../ui/components/Common/DataTable/Table';
import type { IOrgUser } from '../interfaces';

export interface IUseOrganizationUsers {
  users: IOrgUser[];
  columns: TableColumn<IOrgUser>[];
  anchorEl: HTMLElement | null;
  selectedUser: IOrgUser | null;
  menuItems: MenuItemType<IOrgUser>[];
  handleOpenMenu: (e: MouseEvent<HTMLButtonElement>, row: unknown) => void;
  handleCloseMenu: () => void;
}

export const useOrganizationUsers = (): IUseOrganizationUsers => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedUser, setSelectedUser] = useState<IOrgUser | null>(null);

  const handleCloseMenu = (): void => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  const handleOpenMenu = (e: MouseEvent<HTMLButtonElement>, row: unknown): void => {
    setAnchorEl(e.currentTarget);
    setSelectedUser(row as IOrgUser);
  };

  const handleEdit = (user: IOrgUser): void => {
    console.log('Editing user:', user);
    handleCloseMenu();
  };

  const handleDelete = (user: IOrgUser): void => {
    console.log('Deleting user:', user);
    handleCloseMenu();
  };

  const menuItems: MenuItemType<IOrgUser>[] = [
    {
      label: 'Update',
      icon: <PencilIcon size={16} />,
      permission: [],
      onClick: (row) => handleEdit(row),
    },
    {
      label: 'Delete Item',
      icon: <TrashIcon size={16} color='#f43f5e' />,
      permission: [],
      onClick: (row) => handleDelete(row),
    },
  ];

  const columns = getOrganizationUserColumns(
    handleOpenMenu,
    handleCloseMenu,
    anchorEl,
    selectedUser,
  );

  return {
    users: MOCK_ORG_USERS,
    columns,
    anchorEl,
    selectedUser,
    menuItems,
    handleOpenMenu,
    handleCloseMenu,
  };
};
